import { useState } from "react";
import { X, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";

const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EmailListInput = ({ value = [], onChange, max = 10 }) => {
  const [draft, setDraft] = useState("");
  const [error, setError] = useState("");
  const add = () => {
    const items = draft.split(/[\s,;]+/).map((e) => e.trim().toLowerCase()).filter(Boolean);
    if (!items.length) return;
    const bad = items.find((e) => !EMAIL_RX.test(e));
    if (bad) return setError(`"${bad}" is not a valid email address`);
    const next = [...new Set([...value, ...items])];
    if (next.length > max) return setError(`You can add up to ${max} emails`);
    onChange(next);
    setDraft("");
    setError("");
  };
  return (
    <div data-testid="site-notify-emails">
      <div className="flex gap-2">
        <Input value={draft} onChange={(e) => { setDraft(e.target.value); setError(""); }} onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } }}
          placeholder="name@example.org, then press Enter" data-testid="site-notify-email-input" />
        <button type="button" onClick={add} className="inline-flex items-center gap-1 rounded-md border px-3 text-sm font-semibold hover:border-[#E60000] hover:text-[#E60000] transition-colors" data-testid="site-notify-email-add"><Plus className="w-4 h-4" />Add</button>
      </div>
      {error && <p className="text-xs text-[#B30000] mt-1.5" data-testid="site-notify-email-error">{error}</p>}
      <div className="flex flex-wrap gap-2 mt-2">
        {value.map((e) => (
          <span key={e} className="inline-flex items-center gap-1.5 rounded-full bg-[#FFF0F0] text-[#B30000] border border-[#FFD6D6] pl-3 pr-1.5 py-1 text-xs font-semibold" data-testid={`site-notify-email-chip-${e}`}>
            {e}
            <button type="button" onClick={() => onChange(value.filter((x) => x !== e))} aria-label={`Remove ${e}`} className="rounded-full p-0.5 hover:bg-[#FFD6D6]" data-testid={`site-notify-email-remove-${e}`}><X className="w-3 h-3" /></button>
          </span>
        ))}
        {!value.length && <span className="text-xs text-gray-500" data-testid="site-notify-email-empty">No emails added. Email copies are off.</span>}
      </div>
    </div>
  );
};
